module.exports = __webpack_public_path__ + "img/wxbacx.d0289dc0.png";